import React, { createContext, useContext } from "react";
import { useFilesUploaderSocketIO } from "@/hooks/socket-io/use-files-uploader-socket-io";

export type FileUploaderContextValue = ReturnType<typeof useFilesUploaderSocketIO>;

const FileUploaderContext = createContext<FileUploaderContextValue | null>(null);

export const FileUploaderProvider = ({ children }: { children: React.ReactNode }) => {
    const fileUploaderSocketIOState = useFilesUploaderSocketIO();

    return (
        <FileUploaderContext.Provider value={fileUploaderSocketIOState}>
            {children}
        </FileUploaderContext.Provider>
    );
};

export const useFileUploader = () => {
    const context = useContext(FileUploaderContext);
    if (!context) {
        throw new Error("useFileUploader must be used within a FileUploaderProvider");
    }
    return context;
};
